import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { createPluginState } from './plugin-factory';
import { rovoAgentsPluginKey } from './plugin-key';
export function createRovoAgentsPlugin(options) {
  return new SafePlugin({
    key: rovoAgentsPluginKey,
    state: createPluginState(options.dispatch,
    // Initial state
    {
      agents: [],
      enabled: false,
      publishDocAndSelection: function publishDocAndSelection() {},
      publish: function publish() {},
      isBrowseModalOpen: false,
      positions: undefined
    }),
    view: function view(_view) {
      return {
        destroy: function destroy() {
          var pluginState = rovoAgentsPluginKey.getState(_view.state);
          pluginState === null || pluginState === void 0 || pluginState.publishDocAndSelection({
            doc: undefined,
            selection: undefined
          });
        }
      };
    }
  });
}